import { api, authApi } from './api'

// GET: 회원 검사
export const checkUserApi = (userId) => authApi.get('/user/check/' + userId)

// POST: 로그인
export const loginApi = (data) => authApi.post('/user/login', data)

// GET: 로그아웃
export const logoutApi = () => authApi.get('/user/logout')

// GET: 아이디 중복 확인
export const checkIdDuplicationApi = (data) =>
	api.post('/user/duplication', data)

// POST: 이메일 인증번호 전송
export const sendCertificationEmailApi = (data) =>
	api.post('/email/verification/signup', data)

// POST: 이메일 인증번호 확인
export const verifyCertificationCodeApi = (data) =>
	api.post('/user/verification/signup', data)

// POST: 회원가입
export const signupApi = (data) => api.post('/user/signup', data)

// GET: 마이페이지 조회
export const getMyPageApi = (userId) => authApi.get('/user/mypage/' + userId)

// PUT: 기본정보 변경
export const changeMypageApi = (data) => authApi.put(`/user/mypage/default`, data)

// PUT: 비밀번호 변경
export const changePasswordApi = (data) => authApi.put('/user/mypage/password', data)

// DELETE: 회원탈퇴
export const deleteUserApi = () => authApi.delete('/user')